// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class CtaCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 1) return
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'free',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: 1.31,
          spacing: 33,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.73,
              spacing: 20,
            },
          },
          '(min-width: 1024px)': {
            slides: {
              perView: 4.13,
              spacing: 20,
            },
          },
          '(min-width: 1700px)': {
            slides: {
              perView: 4.27,
              spacing: 25,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
